// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__uGlJc","row":"ProcedureTreatmentSummary_row__XnqnS"};